<mat-horizontal-stepper #horizontalStepper linear="true" class="mat-elevation-z2" fxShow="false" fxShow.gt-sm>
  <mat-step [stepControl]="billingForm" label="Billing address">
    <form [formGroup]="billingForm">
      <div fxLayout=" row wrap">
        <div fxFlex="100">
          <mat-checkbox (click)="billingAddress()" color="primary">Same As Registered Billing Address</mat-checkbox>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Address :</mat-label>
            <input matInput placeholder="Address" formControlName="invoiceToAddress">
            <mat-error *ngIf="billingForm.controls.invoiceToAddress.errors?.required">Address is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>City:</mat-label>
            <input matInput placeholder="City" formControlName="invoiceToCity">
            <mat-error *ngIf="billingForm.controls.invoiceToCity.errors?.required">City is required</mat-error>
            <mat-error *ngIf="billingForm.controls.invoiceToCity.hasError('pattern')">Please, Enter City (Only
              characters are allowed)</mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
             <mat-label>State</mat-label>
                <mat-select  formControlName="invoiceToState">
                  <mat-option *ngFor="let state of states" [value]="state.stateName">
                    <span>{{state.stateName}}</span>
                  </mat-option>
                </mat-select>
            <mat-error *ngIf="billingForm.controls.invoiceToState.errors?.required">State is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Phone</mat-label>
            <input matInput placeholder="Phone" formControlName="invoiceToPhone">
            <mat-error *ngIf="billingForm.controls.invoiceToPhone.errors?.required">Phone is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Pin</mat-label>
            <input matInput placeholder="Pin" formControlName="invoiceToPin">
            <mat-error *ngIf="billingForm.controls.invoiceToPin.errors?.required">Pin is required</mat-error>
          </mat-form-field>
        </div>
		    <div fxFlex="100" fxFlex.gt-sm="25" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>GSTIN/UIN</mat-label>
            <input matInput placeholder="GSTIN/UIN" formControlName="invoiceToGSTINUIN">
            <mat-error *ngIf="billingForm.controls.invoiceToGSTINUIN.errors?.required">GSTIN/UIN is required</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1">
        <button mat-mini-fab matStepperNext color="primary" matTooltip="Next" matTooltipPosition="after">
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>
    </form>

  </mat-step>
  <mat-step [stepControl]="deliveryForm" label="Shipping Address">
    <form [formGroup]="deliveryForm">
      <div fxLayout=" row wrap">
        <div fxFlex="100">
          <mat-checkbox (click)="shippingAddress()" color="primary">Same As Registered Shipping Address</mat-checkbox>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Address :</mat-label>
            <input matInput placeholder="Address" formControlName="shipToAddress">
            <mat-error *ngIf="deliveryForm.controls.shipToAddress.errors?.required">Address is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>City:</mat-label>
            <input matInput placeholder="City" formControlName="shipToCity">
            <mat-error *ngIf="deliveryForm.controls.shipToCity.errors?.required">City is required</mat-error>
            <mat-error *ngIf="deliveryForm.controls.shipToCity.hasError('pattern')">Please, Enter valid City (Only
              characters
              are allowed)</mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>State</mat-label>
            <mat-select  formControlName="shipToState">
              <mat-option *ngFor="let state of states" [value]="state.stateName">
                <span>{{state.stateName}}</span>
              </mat-option>
            </mat-select>
            <!-- <input matInput placeholder="State" formControlName="shipToState"> -->
            <mat-error *ngIf="deliveryForm.controls.shipToState.errors?.required">State is required</mat-error>
            <!-- <mat-error *ngIf="deliveryForm.controls.shipToState.hasError('pattern')">Please, Enter valid State (Only
              characters
              are allowed)</mat-error> -->
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Phone</mat-label>
            <input matInput placeholder="Phone" formControlName="shipToPhone">
            <mat-error *ngIf="deliveryForm.controls.shipToPhone.errors?.required">Phone is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Pin</mat-label>
            <input matInput placeholder="Pin" formControlName="shipToPin">
            <mat-error *ngIf="deliveryForm.controls.shipToPin.errors?.required">Pin is required</mat-error>
          </mat-form-field>
        </div>

      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1">
        <button mat-mini-fab matStepperNext color="primary" matTooltip="Next" matTooltipPosition="after">
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step label="Review Order">
    <div fxLayout="row wrap">
      <div fxFlex="100" class="p-1">
        <h3 class="text-muted">Shopping Cart</h3>
        <div class="divider"></div>
        <div class="mat-table review-order-table">
          <div class="mat-header-row">
            <div class="mat-header-cell">Product</div>
            <div class="mat-header-cell">Name</div>
            <div class="mat-header-cell">Unit Price</div>
            <div class="mat-header-cell">Quantity</div>
            <div class="mat-header-cell">Sub Total</div>
            <div class="mat-header-cell">GST(%)</div>
            <div class="mat-header-cell">Total</div>
          </div>
          <div *ngFor="let product of appService.Data.cartList" class="mat-row">
            <div class="mat-cell"><img [src]="product.productImages[0].imageUrl"></div>
            <div class="mat-cell">{{product.productName}}</div>
            <div class="mat-cell">Rs.{{product.productPrice | number : '1.2-2'}}</div>
            <div class="mat-cell text-muted"> {{product.cartCount}} </div>
            <div class="mat-cell">Rs.{{subTotal[product.productId] | number : '1.2-2'}}</div>
            <div class="mat-cell">{{product.cgst | number : '1.2-2'}}</div>
            <div class="mat-cell">Rs.{{total[product.productId] | number : '1.2-2'}}</div>
          </div>
        </div>
      </div>
    </div>
    <div fxLayout="row wrap">
      <div fxFlex="100" class="p-1">
        <h3 class="text-muted mt-2">Billing information</h3>
        <div class="divider"></div>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">Name:</p>
        <p>{{billingForm.controls.invoiceToAddress.value}} </p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">City:</p>
        <p>{{billingForm.controls.invoiceToCity.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">State:</p>
        <p>{{billingForm.controls.invoiceToState.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">shipToPhone:</p>
        <p>{{billingForm.controls.invoiceToPhone.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">Pin:</p>
        <p>{{billingForm.controls.invoiceToPin.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">GSTIN/UIN:</p>
        <p>{{billingForm.controls.invoiceToGSTINUIN.value}}</p>
      </div>

    </div>
    <div fxLayout="row wrap">
      <div fxFlex="100" class="p-1">
        <h3 class="text-muted mt-2">Shipping information</h3>
        <div class="divider"></div>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">Address:</p>
        <p>{{deliveryForm.controls.shipToAddress.value}} </p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">City:</p>
        <p>{{deliveryForm.controls.shipToCity.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">State:</p>
        <p>{{deliveryForm.controls.shipToState.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">Phone:</p>
        <p>{{deliveryForm.controls.shipToPhone.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">Pin:</p>
        <p>{{deliveryForm.controls.shipToPin.value}}</p>
      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" class="p-1">
      <h2><span class="text-muted mr-1">SubTotal Price:</span><span>Rs.{{grandSubTotalFinal | number : '1.2-2'}}</span></h2>
      <h2><span class="text-muted mr-1">GST:</span><span>Rs.{{gstTotal}}</span></h2>
      <h2><span class="text-muted mr-1">Total Price:</span><span>Rs.{{ (grandTotal) | number : '1.2-2'}}</span></h2>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1">
      <button mat-mini-fab matStepperPrevious color="primary" matTooltip="Back" matTooltipPosition="before"
        class="mr-1">
        <mat-icon>navigate_before</mat-icon>
      </button>
      <button mat-flat-button color="primary" class="mat-elevation-z6" type="submit"
        (click)="saveOrder(billingForm.value,deliveryForm.value)" form="ngForm">
        Confirm Order
      </button>
    </div>
  </mat-step>
</mat-horizontal-stepper>
<mat-vertical-stepper #verticalStepper linear="true" class="mat-elevation-z2" fxHide="false" fxHide.gt-sm>
  <mat-step [stepControl]="billingForm" label="Billing address">
    <form [formGroup]="billingForm">
      <div fxLayout="row wrap">
        <div fxFlex="100">
          <mat-checkbox (click)="billingAddress()" color="primary">Same As Billing Address</mat-checkbox>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Address</mat-label>
            <input matInput placeholder="Address" formControlName="invoiceToAddress">
            <mat-error *ngIf="billingForm.controls.invoiceToAddress.errors?.required">Address is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>City</mat-label>
            <input matInput placeholder="City" formControlName="invoiceToCity">
            <mat-error *ngIf="billingForm.controls.invoiceToCity.errors?.required">City is required</mat-error>
            <mat-error *ngIf="billingForm.controls.invoiceToCity.hasError('pattern')">Please, Enter valid City (Only
              characters
              are allowed)</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>State</mat-label>
            <input matInput placeholder="State" formControlName="invoiceToState">
            <mat-error *ngIf="billingForm.controls.invoiceToState.errors?.required">State is required</mat-error>
            <mat-error *ngIf="billingForm.controls.invoiceToState.hasError('pattern')">Please, Enter valid State (Only
              characters
              are allowed)</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Phone</mat-label>
            <input matInput placeholder="Phone" formControlName="invoiceToPhone">
            <mat-error *ngIf="billingForm.controls.invoiceToPhone.errors?.required">Phone is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Pin</mat-label>
            <input matInput placeholder="Pin" formControlName="invoiceToPin">
            <mat-error *ngIf="billingForm.controls.invoiceToPin.errors?.required">Pin is required</mat-error>
          </mat-form-field>
        </div>

      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1">
        <button mat-mini-fab matStepperNext color="primary" matTooltip="Next" matTooltipPosition="after">
          <mat-icon>expand_more</mat-icon>
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="deliveryForm" label="Shipping Address">
    <form [formGroup]="deliveryForm">
      <div fxLayout=" row wrap">
        <div fxFlex="100">
          <mat-checkbox (click)="shippingAddress()" color="primary">Same As Shipping Address</mat-checkbox>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Address :</mat-label>
            <input matInput placeholder="Address" formControlName="shipToAddress">
            <mat-error *ngIf="deliveryForm.controls.shipToAddress.errors?.required">Address is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>City:</mat-label>
            <input matInput placeholder="shipToCity" formControlName="shipToCity">
            <mat-error *ngIf="deliveryForm.controls.shipToCity.errors?.required">City is required</mat-error>
            <mat-error *ngIf="deliveryForm.controls.shipToCity.hasError('pattern')">Please, Enter valid City (Only
              characters
              are allowed)</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>State</mat-label>
            <input matInput placeholder="shipToState" formControlName="shipToState">
            <mat-error *ngIf="deliveryForm.controls.shipToState.errors?.required">State is required</mat-error>
            <mat-error *ngIf="deliveryForm.controls.shipToState.hasError('pattern')">Please, Enter valid State (Only
              characters
              are allowed)</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Phone</mat-label>
            <input matInput placeholder="shipToPhone" formControlName="shipToPhone">
            <mat-error *ngIf="deliveryForm.controls.shipToPhone.errors?.required">shipToPhone is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Pin</mat-label>
            <input matInput placeholder="shipToPin" formControlName="shipToPin">
            <mat-error *ngIf="deliveryForm.controls.shipToPin.errors?.required">shipToPin is required</mat-error>
          </mat-form-field>
        </div>

      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1">
        <button mat-mini-fab matStepperNext color="primary" matTooltip="Next" matTooltipPosition="after">
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step label="Review Order">
    <div fxLayout="row wrap">
      <div fxFlex="100" class="p-1">
        <h3 class="text-muted">Shopping Cart</h3>
        <div class="divider"></div>
        <div class="mat-table review-order-table">
          <div class="mat-header-row">
            <div class="mat-header-cell">Product</div>
            <div class="mat-header-cell">Name</div>
            <div class="mat-header-cell">Unit Price</div>
            <div class="mat-header-cell">Quantity</div>
            <div class="mat-header-cell">Sub Total</div>
            <div class="mat-header-cell">GST(%)</div>
            <div class="mat-header-cell">Total</div>
          </div>
          <div *ngFor="let product of appService.Data.cartList" class="mat-row">
            <div class="mat-cell"><img [src]="product.productImages[0].imageUrl"></div>
            <div class="mat-cell">{{product.productName}}</div>
            <div class="mat-cell">Rs.{{product.productPrice | number : '1.2-2'}}</div>
            <div class="mat-cell text-muted"> 1 </div>
            <div class="mat-cell">Rs.{{subTotal[product.productId] | number : '1.2-2'}}</div>
            <div class="mat-cell">{{product.cgst | number : '1.2-2'}}</div>
            <div class="mat-cell">Rs.{{total[product.productId] | number : '1.2-2'}}</div>
          </div>
        </div>
      </div>
    </div>
    <div fxLayout="row wrap">
      <div fxFlex="100" class="p-1">
        <h3 class="text-muted mt-2">Billing information</h3>
        <div class="divider"></div>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">Name:</p>
        <p>{{billingForm.controls.invoiceToAddress.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">State:</p>
        <p>{{billingForm.controls.invoiceToCity.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">State:</p>
        <p>{{billingForm.controls.invoiceToState.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">Phone:</p>
        <p>{{billingForm.controls.invoiceToPhone.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">shipToPin:</p>
        <p>{{billingForm.controls.invoiceToPin.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">GSTIN/UIN:</p>
        <p>{{billingForm.controls.invoiceToGSTINUIN.value}}</p>
      </div>

    </div>
    <div fxLayout="row wrap">
      <div fxFlex="100" class="p-1">
        <h3 class="text-muted mt-2">Shipping information</h3>
        <div class="divider"></div>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">Address:</p>
        <p>{{deliveryForm.controls.shipToAddress.value}} </p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">City:</p>
        <p>{{deliveryForm.controls.shipToCity.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">State:</p>
        <p>{{deliveryForm.controls.shipToState.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">Phone:</p>
        <p>{{deliveryForm.controls.shipToPhone.value}}</p>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
        <p class="text-muted">Pin:</p>
        <p>{{deliveryForm.controls.shipToPin.value}}</p>
      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" class="p-1">
      <h2><span class="text-muted mr-1">SubTotal Price:</span><span>Rs.{{grandSubTotalFinal | number : '1.2-2'}}</span></h2>
      <h2><span class="text-muted mr-1">GST:</span><span>Rs.{{gstTotal}}</span></h2>
      <h2><span class="text-muted mr-1">Total Price:</span><span>Rs.{{ (grandTotal) | number : '1.2-2'}}</span></h2>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1">
      <button mat-mini-fab matStepperPrevious color="primary" matTooltip="Back" matTooltipPosition="before"
        class="mr-1">
        <mat-icon>expand_less</mat-icon>
      </button>
      <button mat-flat-button color="primary" class="mat-elevation-z6" type="submit"
        (click)="saveOrder(billingForm.value,deliveryForm.value)" form="ngForm">
        Confirm Order
      </button>
    </div>
  </mat-step>
</mat-vertical-stepper>